import { render } from "./LevelComponent.vue?vue&type=template&id=40080052"
import script from "./LevelComponent.vue?vue&type=script&lang=js"
export * from "./LevelComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__